"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var localeDataseTranslations = require('@wix/locale-dataset-data/resources/translations/messages_en.json');
var locale_dataset_javascript_1 = require("@wix/locale-dataset-javascript");
exports.get = function (getter, fallback) {
    try {
        var val = getter();
        return val !== void 0 ? val : fallback;
    }
    catch (e) {
        return fallback;
    }
};
exports.omit = function (key) { return function (obj) {
    var _a = key, _v = obj[_a], rest = __rest(obj, [typeof _a === "symbol" ? _a : _a + ""]);
    return rest;
}; };
exports.omitMedia = exports.omit('media');
exports.createWixCodeDateTimeObject = {
    fromISODate: function (ISODate) { return ({ $date: ISODate }); },
    fromTimestamp: function (timestamp) {
        return exports.createWixCodeDateTimeObject.fromISODate(new Date(timestamp).toString());
    },
};
var extractSubdivisionCode = function (subdivision) {
    var subdivisions = subdivision.split('-');
    if (subdivisions && subdivisions.length > 1) {
        return subdivisions[1];
    }
    return subdivision;
};
exports.createWixCodeAddressObject = function (address) {
    if (!address) {
        return {
            formatted: '',
        };
    }
    var localizedAddress = __assign({}, address);
    if (address.country) {
        var countryData = locale_dataset_javascript_1.default.getCountryByKey(address.country);
        localizedAddress.country = countryData ? localeDataseTranslations[countryData.displayName] : null;
    }
    if (address.subdivision) {
        var subdivisionData = locale_dataset_javascript_1.default.getStateByKey(address.country, extractSubdivisionCode(address.subdivision));
        localizedAddress.subdivision = subdivisionData ? localeDataseTranslations[subdivisionData.displayName] : null;
    }
    var formatted = locale_dataset_javascript_1.default.getFormattedAddress(localizedAddress, localizedAddress.country).trim();
    return { formatted: formatted ? formatted : '' };
};
//# sourceMappingURL=utils.js.map